import { request } from './client';
import {
  Card,
  CardCurve,
  CardPreviewIntervals,
  CardTemplate,
} from '../types/card';

export async function fetchCards(deck_id?: string): Promise<{ items: Card[]; total: number }> {
  const query = deck_id ? `?deck_id=${encodeURIComponent(deck_id)}` : '';
  return request<{ items: Card[]; total: number }>(`/cards${query}`);
}

export async function createCard(payload: {
  word_id: string;
  deck_id: string;
  template: CardTemplate;
}): Promise<Card> {
  return request<Card>('/cards', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateCard(
  id: string,
  payload: { suspended?: boolean; buried_until?: string | null }
): Promise<Card> {
  return request<Card>(`/cards/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export async function fetchCardCurve(id: string): Promise<CardCurve> {
  return request<CardCurve>(`/cards/${encodeURIComponent(id)}/curve`);
}

export async function fetchCardPreview(id: string): Promise<CardPreviewIntervals> {
  return request<CardPreviewIntervals>(`/cards/${encodeURIComponent(id)}/preview`);
}
